import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./VerificationCode.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import {
  Box,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
// import forgetBackImg from "../../assets/forgetBackImg.png";
const VerificationCode = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [otp, setotp] = useState();
  const [otpVisible, setOtpVisible] = useState();
  const location = useLocation();
  
  const handleOnVerify = ()=>{
    let userData = {
      id: location?.state?.id,
      code: otp
    }
    if(!otp){
      dispatch(
        showAlert({ type: "Error", message: "Please enter code" })
      );
    }else{
      dispatch(AuthMiddleware.verifyCode(userData)).then((data)=>{
        
        navigate("/enterNewPassword",{
          state: {location, data}
        })
        
      }).catch((err)=>{
        console.log("error===>>>", err);
      });
    } 
  };
  const handleOnResend = ()=>{
    let userData = {
      email: location?.state?.email,
    }
      dispatch(AuthMiddleware.forgetPassword(userData))
  }
  return (
    <Box boxClass={styles.box}>
      <div className={styles.header}>
        <IoIosArrowBack
          color="var(--black-color)"
          size={30}
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
      </div>
      <div className={styles.headingDiv}>
        <TextComponent text={"Verification Code"} textClass={styles.heading} />
        <TextComponent
          text={
            "Please enter the verification code which was sent to your registered email address"
          }
          textClass={styles.subHeading}
        />
        <InputField
          label={"Enter Code"}
          placeholder={"••••••"}
          value={otp}
          maxLength={6}
          onChange={(e) => setotp(e.target.value)}
          rightIcon={
            otpVisible ? (
              <BsEyeSlashFill color="var(--light-grey)" size={15} />
            ) : (
              <BsEyeFill color="var(--light-grey)" size={15} />
            )
          }
          type={otpVisible ? "password" : "text"}
          onRightIconPress={(e) => setOtpVisible(!otpVisible)}
        />
        <TextComponent
          text={"If you don't receive? "}
          textClass={styles.subHeading}
        ><span className={styles.resendBtn} onClick={handleOnResend}>Resend</span></TextComponent>

        <SubmitButton
          title={"Verify"}
          btnClass={styles.btn}
          onClick={handleOnVerify}
        />
      </div>
    </Box>
  );
};
export default VerificationCode;
